import React, { useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

const faqs = [
  {
    question: "What is Capital Gains Tax (CGT)?",
    answer:
      "Capital Gains Tax is the tax HMRC charges on the profit made when you’ve “disposed” of an asset, such as selling a property.",
  },
  {
    question: "If I am liable to pay CGT, when will I have to pay it?",
    answer:
      "Since 6th April 2020, when you sell a property, HMRC requires you to file & pay your CGT within 60 days of completing the sale.",
  },
  {
    question: "When do I not have to pay CGT?",
    answer:
      "If the gain is covered by exemptions like the Annual Exemption (£3,000 for 2025/26) or Private Residence Relief, you may not have to pay CGT. For eligibility, visit: https://www.gov.uk/tax-relief-selling-home.  Also, spouses/civil partners transferring property or sales at a loss usually don’t trigger CGT.  ",
  },
  {
    question: "How can I find out whether I need to file & pay CGT?",
    answer:
      "We’ve simplified the process! Take our free quick assessment to check if you need to file & pay CGT.",
      linkText: "Click here for the free assessment",
  linkHref: "https://chatcgt.typeform.com/to/rUw4Egui",
  },
  {
    question:
      "I am thinking of selling a property. Can I get advice on how to reduce my CGT when I eventually sell?",
    answer:
      "You can use our free assessment and choose calculate my CGT only service and we can help you plan ahead.",
          linkText: "Click here for the free assessment",
  linkHref: "https://chatcgt.typeform.com/to/rUw4Egui",
  },
  {
    question:
      "For the inaccuracy penalties, what does “lack of reasonable care” mean?",
    answer:
      "‘Reasonable care’ means taking steps to keep your tax affairs accurate — like using a qualified agent or checking details with HMRC. If HMRC finds you didn’t take reasonable steps, you may face a penalty.",
  },
];

function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);
  const [ctaVisible, setCtaVisible] = useState(false);
  const [revealed, setRevealed] = useState(Array(faqs.length).fill(false));

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const items = document.querySelectorAll(".faq-item");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Array.from(items).indexOf(entry.target);
          if (entry.isIntersecting && !revealed[index]) {
            setTimeout(() => {
              setRevealed((prev) => {
                const updated = [...prev];
                updated[index] = true;
                return updated;
              });
              observer.unobserve(entry.target);
            }, index * 150);
          }
        });
      },
      { threshold: 0.2 }
    );
    items.forEach((item) => observer.observe(item));

    const delayStep = 25;
    const delayDuration = 150; // delay for each item
    const totalTime = (items.length - 1) * delayStep + delayDuration;

    const timer = setTimeout(() => {
      setCtaVisible(true);
    }, totalTime);

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, [revealed]);

  return (
    <section className="faq-section bg-default text-center" id="faqs">
      <div className="container px-4 px-lg-5">
        <h2 className="text-white mb-4 big-title">Frequently Asked Questions</h2>
        <p className="text-white-80 lead mb-5">
          Have a question about CGT or our services? Find answers below or reach out to us any time.
        </p>

        <div className="faq-list">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${revealed[index] ? "show" : ""} ${openIndex === index ? "open" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
              >
                {item.question}
                <FaChevronDown className="chevron" />
              </button>
              <div className="faq-answer">
                <p>{item.answer}   <a href={item.linkHref} className="text-accent" target="_blank" rel="noopener noreferrer">
    {item.linkText}
  </a></p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA at the bottom */}
        <div className={`faq-cta mt-5 ${ctaVisible ? "show" : ""}`}>
          <h4 className="text-white mb-2"><b>Check your CGT now.</b></h4>
          <p className="text-white-80 mb-4">
            We’ve simplified the process of working out whether you need to make a submission under file and pay. All for free!
          </p>
          <a href="https://chatcgt.typeform.com/to/rUw4Egui" target="_blank" className="btn btn-primary px-4 py-3">
            Check now
          </a>
        </div>
      </div>
    </section>
  );
}

export default Faqs;
